/**
 * @generated SignedSource<<7abf4a548350441babdb42190d953bff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateContentLikeInput = {
  contentId: string;
  contentUsageId?: string | null;
  emojiAlias?: string | null;
  emojiCode?: string | null;
};
export type ContentReactionButtonMutation$variables = {
  input: UpdateContentLikeInput;
};
export type ContentReactionButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly id: string;
    } | null;
  };
};
export type ContentReactionButtonMutation = {
  response: ContentReactionButtonMutation$data;
  variables: ContentReactionButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateContentLikeResponse",
    "kind": "LinkedField",
    "name": "updateContentLike",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ContentLike",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContentReactionButtonMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContentReactionButtonMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "310f10c6000e96b0306b843d1a69f674",
    "id": null,
    "metadata": {},
    "name": "ContentReactionButtonMutation",
    "operationKind": "mutation",
    "text": "mutation ContentReactionButtonMutation(\n  $input: UpdateContentLikeInput!\n) {\n  response: updateContentLike(input: $input) {\n    node {\n      id\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f83482b148147ea56b7fcce4fb48131";

export default node;
